import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Музейный туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Разновидность туризма, специфика которого заключается в использовании туристского потенциала
                        музеев и прилегающих к ним территорий.</p>
                    <div className="two-col-cell">
                        <ul>
                            <li><a href='https://brestobl.com/pruzany/palac/glw1.htm'>Пружанский палацик</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}